import { render, staticRenderFns } from "./Punycode.vue?vue&type=template&id=83c2010c"
import script from "./Punycode.vue?vue&type=script&lang=js"
export * from "./Punycode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports